import { submitGiftAddressAPI } from '../../../../shared/api/demo.js'

export const GIFT_SUBMITTED = 'GIFT_SUBMITTED'
export const GIFT_SUBMITTING = 'GIFT_SUBMITTING'
export const GIFT_ERROR = 'GIFT_ERROR'

export function submitGiftAddress(preauthToken, email, firstName, lastName, company, address1, city, state, zip, country) {
	return dispatch => {
		dispatch({ type: GIFT_SUBMITTING })

		return submitGiftAddressAPI(preauthToken, email, firstName, lastName, company, address1, city, state, zip, country).then(response => {

			dispatch({ type: GIFT_SUBMITTED })

		}).catch(err => {

			let errorMessage = 'An unknown error has occurred [G05]'

			if (err.response) {
				// API response provided
				switch (err.response.status) {
					case 400: {
						err.response.json().then(res => {
							const { message } = res
							errorMessage = message || 'An unknown error has occurred [G01]'
							dispatch({ type: GIFT_ERROR, payload: errorMessage })
						})
						return // Don't dispatch error yet, wait for json parsing
					}

					case 401:
					case 403: {
						errorMessage = 'Your session has expired. Please refresh the page and try again. [G02]'
					} break

					case 500: {
						errorMessage = 'Service unavailable [G03]'
					} break

					default: {
						errorMessage = 'An unknown error has occurred [G04]'
					} break
				}
			}

			dispatch({ type: GIFT_ERROR, payload: errorMessage })
		})
	}
}
